<template>
  <router-view class="view" />
</template>

<style lang="scss">
// Ne rien écrire ici, tout est importé dans main.js
</style>
